import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { LogService } from 'htv-lib'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { EventService } from '../../services/event.service'
import { RouterService } from '../../services/router.service'

@Component({
  selector: 'app-external-link',
  standalone: true,
  imports: [],
  templateUrl: './external-link.component.html',
  styleUrls: ['./external-link.component.scss'],
})
export class ExternalLinkComponent implements OnInit, OnDestroy {
  eventSubscription?: Subscription
  externalUrl: SafeResourceUrl = ''

  constructor(
    private eventService: EventService,
    private logService: LogService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const url = params['actionNavigationUrl']
      if (url) {
        this.externalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url)
        this.registerEventListener()
      } else {
        this.logService.error('No url provided, sending back user to home')
        this.routerService.goToHome()
      }
    })
  }

  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((event: string) => {
      const iframe = document.querySelector('#external-link') as HTMLIFrameElement | null
      const iframeWin = iframe?.contentWindow
      if (!iframeWin) return
      iframeWin.postMessage(event, '*')
    })
  }
}
